import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
var defaults = {
  day: 'EVERY_DAY',
  startMinute: 0,
  endMinute: 0
};

var AvailableTimeChunk = /*#__PURE__*/function (_Record) {
  _inherits(AvailableTimeChunk, _Record);

  function AvailableTimeChunk() {
    _classCallCheck(this, AvailableTimeChunk);

    return _possibleConstructorReturn(this, _getPrototypeOf(AvailableTimeChunk).apply(this, arguments));
  }

  return AvailableTimeChunk;
}(Record(defaults));

export { AvailableTimeChunk as default };